import { Injectable } from '@angular/core';
import { HttpHelper } from '../../http-helper';
import { Observable } from 'rxjs';
import { IssueTypesResponse } from '../models/issue-type.model';

@Injectable({providedIn: 'root'})
export class IssueTypeService {

  constructor(private httpHelper: HttpHelper) {
  }

  getIssueTypes(): Observable<IssueTypesResponse> {
    return this.httpHelper.getRequest("/jira/issuetype")
  }
}
